/**
 * Filestack rejects uploads with 401/403 (or "Invalid security"/policy-expired errors) once the
 * signed upload policy expires. Detect those failures so upload paths can refresh credentials and
 * retry once instead of surfacing a generic failure.
 */
export function getIsLikelyFilestackAuthError(error: unknown): boolean {
  const status = getErrorResponseStatus(error);
  if (status === 401 || status === 403) return true;
  if (!(error instanceof Error)) return false;

  return /policy|signature|unauthorized|forbidden|invalid security/i.test(error.message);
}

function getErrorResponseStatus(error: unknown): number | null {
  if (typeof error !== 'object' || error === null) return null;
  if (!('response' in error)) return null;

  const { response } = error;
  if (typeof response !== 'object' || response === null) return null;
  if (!('status' in response)) return null;

  const { status } = response;
  return typeof status === 'number' ? status : null;
}
